module.exports = __webpack_public_path__ + "static/img/per4.9f3b4ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per4.jpg
// module id = maPk
// module chunks = 41